import { render } from "./Merit.vue?vue&type=template&id=12097b2a"
import script from "./Merit.vue?vue&type=script&lang=js"
export * from "./Merit.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/PROD_AptokPromotion/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__